import BaseListPresenter from "../../../base/BaseListPresenter";
import { downloadCSV } from "./utils/utils";

class productivityReportPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    getObjectUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      getObjectUseCase
    );
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  onChangePassword(value, field) {
    this.password[field] = value;
  }

  async onChangePicture(value) {
    this.change["picture"] = value;
    await this.submit();
    this.view.reload();
  }

  async onSubmitPassword() {
    const { oldPassword, newPassword, confirmNewPassword } = this.password;
    if (newPassword !== confirmNewPassword) {
      this.view.showError("Password must be the same");
      return;
    }
    try {
      const user = this.object;
      await this.signInUseCase.execute(
        {
          username: user.username,
          password: oldPassword,
        },
        { token: false }
      );
      this.change["password"] = this.password["newPassword"];
      await this.submit();
    } catch (error) {
      if (error.code === 404) {
        this.view.showError("Invalid old password");
        return;
      }
      this.view.showError(error);
    }
  }

  async getRecruiters() {
    const collection = "users";
    const query = {
      where: {
        "roles.id": "Recruiter",
      },
      include: ["all"],
    };

    try {
      return await this.findObjectUseCase.execute(collection, query);
    } catch (error) {
      this.view.showError(error);
      return [];
    }
  }

  async getReports() {
    const collection = "recruiters_report";
    const { startDate, endDate, currentDate } = this.view.state;

    let isoStart, isoEnd;

    if (startDate && endDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);

      isoStart = start.toISOString();
      isoEnd = end.toISOString();
    } else {
      const today = new Date(currentDate);
      const startOfToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );

      startOfToday.setHours(0, 0, 0, 0);
      const endOfToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );

      endOfToday.setHours(23, 59, 59, 999);
      isoStart = startOfToday.toISOString();
      isoEnd = endOfToday.toISOString();
    }

    console.log(isoStart, isoEnd);

    const query = {
      include: ["all"],
      where: {
        created: { $gte: isoStart, $lte: isoEnd },
      },
    };

    try {
      this.showProgress();
      return await this.findObjectUseCase.execute(collection, query);
    } catch (error) {
      this.view.showError(error);
      return [];
    }
  }

  async calculateReports() {
    try {
      this.showProgress();

      const recruiters = await this.getRecruiters();
      const reports = await this.getReports();
      console.log("recruiters", recruiters);
      console.log("reports", reports);
      const statuses = [
        "invited",
        "showedUp",
        "walkIn",
        "interviewed",
        "qualified",
      ];

      const result = recruiters.map((recruiter) => {
        const recruiterReports = reports.filter(
          (r) => r.recruiter && r.recruiter.id === recruiter.id
        );

        const counts = statuses.reduce((acc, status) => {
          acc[status] = recruiterReports.filter(
            (r) => r.status === status
          ).length;
          return acc;
        }, {});

        const recruiterName = `${recruiter?.employee?.firstName} ${
          recruiter?.employee?.middleName || ""
        } ${recruiter?.employee?.lastName}`;

        const qualifiedApplicants = recruiterReports
          .filter((r) => r.status === "qualified")
          .map((r) => r.applicant);

        const clients = recruiterReports
          .filter((r) => r.status === "qualified")
          .map((r) => r.client);

        const locations = recruiterReports
          .filter((r) => r.status === "qualified")
          .map((r) => r.location);

        return {
          name: `${recruiterName}`,
          ...counts,
          applicants: qualifiedApplicants,
          clients: clients,
          locations: locations,
        };
      });
      console.log(reports);
      this.view.setState({ reports: result });

      this.hideProgress();
    } catch (error) {
      this.view.showError(error);
    }
  }

  downloadCSV(reports, startDate, endDate) {
    const dateStart = new Date(startDate);
    const startStr = `${dateStart.getFullYear()}-${
      dateStart.getMonth() + 1
    }-${dateStart.getDate()}`;

    console.log(startDate, endDate);
    let formattedDate;
    if (endDate) {
      const dateEnd = new Date(endDate);
      const endStr = `${dateEnd.getFullYear()}-${
        dateEnd.getMonth() + 1
      }-${dateEnd.getDate()}`;
      formattedDate = `${startStr} -> ${endStr}`;
    } else {
      formattedDate = startStr;
    }
    downloadCSV(reports, formattedDate);
    return;
  }
}

export default productivityReportPresenter;
